export const subscriptionSortingValues = {
  NAME: 'partner_name',
  PARTNER_ID: 'partner_id',
  ITEMS: 'items',
  STATUS: 'status',
  LAST_MODIFIED: 'updated_at',
  TRIAL_END: 'trial_end',
};
